$(document).on('click', '.story__video-play-cion, .story__video', function (e) {
  e.stopPropagation(); 
  e.preventDefault();  

  const $wrap = $(this).closest('.story__video-wrap');
  const $video = $wrap.find('video');
  const videoEl = $video.get(0);
  const $playBtn = $wrap.find('.story__video-play-cion');

  if (!videoEl) return;

  if (videoEl.paused) {
    videoEl.play();
    $playBtn.addClass('playing').hide(); 
  } else {
    videoEl.pause();
    $playBtn.removeClass('playing').show(); 
  }
});




if ($(window).width() > 768) {
    $(".video__item-video").on("click", function () {
        var video_src = $(this).parent().attr("data-video-embed");
        const classList = $(this).attr("class").split(" ");

        let parent = $(this).closest(".video__item").find(".video__bot-wrap");
            let image = parent.find(".video__channel-img img").attr("src");
            let title = parent.find(".video__channel-name h3").text();
            let sub_title = parent.find(".video__channel-name p").text();
            
         $(".video__desk-channel-img img").attr("src", image);
          $(".video__desk-channel-name h3").text(title);
          $(".video__desk-channel-name p").text(sub_title);

        if (video_src.includes("youtube") || video_src.includes("vimeo")) {
            video_src += (video_src.includes("?") ? "&" : "?") + "autoplay=1";
        }

        // Update the iframe inside .video__desk-video
        $(".video__desk-video iframe").attr("src", video_src);
    });
}










if ($(window).width() < 768) {

    $(".video__hosted").click(function () {
        var video = $(this).find("video").get(0);
        var icon_image = $(this).find(".video__play-icon");

        if (video.paused) {

            $("video").each(function () {
                this.pause();
                $(".video__play-icon").css("display", "block");
            });

            $(".video__youtube iframe").each(function () {
                var src = $(this).attr("src");
                $(this).attr("src", src);
            });

            video.play();
            icon_image.css("display", "none");
        } else {
            video.pause();
            icon_image.css("display", "block");
        }
    });


// $(".ytmCuedOverlayPlayButton").on("click",function(){
//     alert();
// })




}




// video-slider start





$('.video-slider__first-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    fade:true,
});


$('.video-slider__second-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    fade:true,
});


$('.video-slider__third-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    fade:true,
});

$('.video-slider__four-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 6000,
    fade:true,
});





// video-slider end
